enum TimeType {
  AM,
  PM
}

export default TimeType
